<template>
  <videoPopup v-if="content.type === 'video' && content.content.length === 1" :dialogTitle="content.title" :visible="dialogVisible" :video_src="content.content[0].url" @dialogClose="dialogCloseHandle"></videoPopup>
  <videoListPopup v-else-if="content.type === 'video' && content.content.length > 1" :dialogTitle="content.title" :visible="dialogVisible" :videoList="content.content" @dialogClose="dialogCloseHandle"></videoListPopup>
  <el-image
    v-else-if="content.type === 'image'"
    ref="imagePopup"
    class="image"
    :src="content.content[0].url"
    :preview-src-list="content.content.map(item => item.url)"
    style="display: none;"
    @click.stop="(e)=> { e.stopPropagation(); }"
  ></el-image>
  <audioPopup v-else-if="content.type === 'audio' && content.content.length === 1" :dialogTitle="content.title" :visible="dialogVisible" :audio_src="content.content[0].url" @dialogClose="dialogCloseHandle"></audioPopup>
  <audioListPopup v-else-if="content.type === 'audio' && content.content.length > 1" :dialogTitle="content.title" :visible="dialogVisible" :audioList="content.content" @dialogClose="dialogCloseHandle"></audioListPopup>
  <threeDPopup
    v-else-if="content.type === '3DModel' && content.content.length === 1"
    :dialogTitle="content.title"
    :dialogVisible="dialogVisible"
    :iframeUrl="content.content[0].url"
    :showInFullPage="true"
    :showInNewPage="true"
    @dialogClose="dialogCloseHandle"
  ></threeDPopup>
  <threeDListPopup
    v-else-if="content.type === '3DModel' && content.content.length > 1"
    :dialogTitle="content.title"
    :dialogVisible="dialogVisible"
    :threeDList="content.content"
    :showInFullPage="true"
    :showInNewPage="true"
    @dialogClose="dialogCloseHandle"
  ></threeDListPopup>
  <interactionQuestionPopup
    v-else-if="content.type === 'interactionQuestion'"
    :dialogVisible="dialogVisible"
    :dialogTitle="content.title"
    :dialogType="content.type"
    @dialogClose="dialogCloseHandle"
    :content="content"
  ></interactionQuestionPopup>
  <chartsPopup
    v-else-if="content.type === 'charts'"
    :dialogVisible="dialogVisible"
    :dialogTitle="content.title"
    :dialogType="content.type"
    @dialogClose="dialogCloseHandle"
    :content="content"
  ></chartsPopup>
  <auxiliaryPopup
    v-else-if="content.type === 'auxiliary'"
    :dialogVisible="dialogVisible"
    :dialogTitle="content.title"
    :dialogType="content.type"
    @dialogClose="dialogCloseHandle"
    :content="content"
  ></auxiliaryPopup>
  <pdfPreview v-else-if="content.type==='expandMenu'" :dialogVisible="dialogVisible" :dialogTitle="content.title" @dialogClose="dialogCloseHandle" :content="content"></pdfPreview>
  <commonPopup v-else :dialogVisible="dialogVisible" :dialogTitle="content.title" :dialogType="content.type" @dialogClose="dialogCloseHandle" :content="content.content"></commonPopup>

</template>
<script>
/*
基础模板组件 的弹窗
*/
import commonPopup from "../commonPopup.vue";
import interactionQuestionPopup from "../interactionQuestion.vue";
import videoPopup from "../../popup/videoPlayer.vue";
import videoListPopup from "../../popup/videoListPlayer.vue";
import audioPopup from "../../popup/audioPlayer.vue";
import audioListPopup from "../../popup/audioListPlayer.vue";
import threeDPopup from "../../popup/threeD.vue";
import threeDListPopup from "../../popup/threeDList.vue";
import chartsPopup from "../chartsPopup.vue";
import auxiliaryPopup from "../auxiliaryPopup.vue";
import pdfPreview from "../pdfPreview.vue";
export default {
  name: "mixIndexPop",
  components: {
    commonPopup,
    interactionQuestionPopup,
    videoPopup,
    videoListPopup,
    audioPopup,
    audioListPopup,
    threeDPopup,
    threeDListPopup,
    chartsPopup,
    auxiliaryPopup,
    pdfPreview,//pdf预览
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogTitle: '',
      dialogType: '',
    }
  },
  methods: {
    showPopupHandle() {
      if(this.content.type === 'image') {
        this.$refs.imagePopup.$el.getElementsByTagName('img')[0].click()
      }else{
        this.dialogVisible = true
      }
    },
    dialogCloseHandle() {
      this.dialogVisible = false
    },
  }
}
</script>
